import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Pedido à mesa',
    [ORDER_METHODS.PICKUP]: 'Takeaway',
    [ORDER_METHODS.DELIVERY]: 'Entrega',
  },
};
